import { Injectable } from '@angular/core';

import { Utils } from '../../classes/utils.class';

@Injectable({
    providedIn: 'root'
})
export class UtilsService extends Utils {}
